/* ─────────────────────────────────────────────────────────────────────────
   Pump / Borewell page — reuses the EXISTING PumpStatusV2 (pumps) and
   PumpStatusV3 (borewells) cards verbatim. Cards self-fetch + self-toggle.
   ──────────────────────────────────────────────────────────────────────── */
import React from "react";
import { useHistory } from "react-router-dom";
import { BiCog } from "react-icons/bi";
import PumpStatusV2 from "../sensor/PumpStatusV2";
import PumpStatusV3 from "../sensor/PumpStatusV3";
import SplashScreen from "../utils/SplashScreen";
import { useSensorList } from "./dashV3.data";
import {
  PageContainer, ContentContainer, OuterBox, SensorType, DeviceGroup,
  PageHeader, BackBtn, HeaderTitle, HeaderCount, Msg,
} from "./dashV3.styles";

/* Sub-labels only when BOTH groups have 2+ devices (same rule as DashboardV2) */
const SubLabel = ({ children }) => (
  <div style={{ width: "100%", fontSize: "0.62rem", fontWeight: 700, color: "#4B5563",
                letterSpacing: "0.1em", textTransform: "uppercase", padding: "4px 8px 2px" }}>
    {children}
  </div>
);

export default function PumpBorewellPageV3() {
  const history = useHistory();
  const { loading, pumps, borewells } = useSensorList();

  const showSubLabels =
    pumps.length > 0 && borewells.length > 0 && (pumps.length > 1 || borewells.length > 1);

  const label =
    pumps.length > 0 && borewells.length > 0 ? "Pump / Borewell"
      : borewells.length > 0 ? "Borewell" : "Pump";

  if (loading) return <SplashScreen />;

  return (
    <PageContainer>
      <PageHeader>
        <BackBtn onClick={() => history.push("/")}>←</BackBtn>
        <BiCog size={20} color="#237A35" />
        <HeaderTitle>Pump / Borewell</HeaderTitle>
        <HeaderCount>{pumps.length + borewells.length} devices</HeaderCount>
      </PageHeader>

      <ContentContainer>
        <OuterBox>
          <SensorType>{label}</SensorType>

          {pumps.length === 0 && borewells.length === 0 && <Msg>No pumps or borewells.</Msg>}

          {pumps.length > 0 && (
            <>
              {showSubLabels && <SubLabel>Pumps</SubLabel>}
              <DeviceGroup>
                {pumps.map((p) => (
                  <PumpStatusV2 key={p.motor_id} motor_id={p.motor_id} sensor_id={p.sensor_id} isBorewell={false} />
                ))}
              </DeviceGroup>
            </>
          )}

          {borewells.length > 0 && (
            <>
              {showSubLabels && <SubLabel>Borewells</SubLabel>}
              <DeviceGroup>
                {borewells.map((b) => (
                  <PumpStatusV3 key={b.motor_id} motor_id={b.motor_id} sensor_id={b.sensor_id} isBorewell={true} />
                ))}
              </DeviceGroup>
            </>
          )}
        </OuterBox>
      </ContentContainer>
    </PageContainer>
  );
}
